"use client";

import React from "react";
import { Map, Landmark, Calculator, ShieldCheck, MousePointerClick } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
const steps = [{
  id: 1,
  title: "Planejamento Inicial",
  shortDesc: "Definição da estrutura jurídica",
  fullDesc: "Analisamos seu perfil e objetivos para definir a melhor estrutura jurídica na Irlanda: atuar como Self-Employed (autônomo) ou abrir uma Limited Company (empresa).",
  icon: Map
}, {
  id: 2,
  title: "Registros Oficiais",
  shortDesc: "Inscrição no CRO e Revenue",
  fullDesc: "Cuidamos de toda a burocracia de registro do seu negócio no Companies Registration Office (CRO) e a inscrição no Revenue para garantir sua conformidade fiscal desde o primeiro dia.",
  icon: Landmark
}, {
  id: 3,
  title: "Configuração Fiscal",
  shortDesc: "VAT, Company Tax e PAYE",
  fullDesc: "Avaliamos a necessidade de registro para VAT, configuramos o Company Tax e estruturamos o sistema de folha de pagamento (PAYE) caso você tenha funcionários ou retire pró-labore.",
  icon: Calculator
}, {
  id: 4,
  title: "Gestão e Conformidade",
  shortDesc: "Acompanhamento contínuo",
  fullDesc: "Mantemos suas obrigações em dia com a entrega de Annual Returns, gestão contábil mensal e suporte especializado para evitar multas e problemas com a legislação irlandesa.",
  icon: ShieldCheck
}];
export default function PathToOpenYourBusiness() {
  return <section id="o-caminho-para-abrir-sua-atividade" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/dublin_map_watermark.png')] bg-cover bg-center mix-blend-luminosity" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24">
          <h2 className="text-3xl font-bold tracking-tight mb-6 text-foreground !font-sans md:text-4xl lg:text-5xl">O Caminho para Abrir sua Atividade</h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Um processo claro, seguro e sem complicações. Nossa equipe especializada guia você em cada etapa para garantir que seu negócio na Irlanda nasça 100% em conformidade com as regras do Revenue e CRO.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 border-t-2 border-dashed border-primary/40 -translate-y-1/2 z-0" />
          
          {}
          <div className="md:hidden absolute top-8 bottom-8 left-8 w-0.5 border-l-2 border-dashed border-primary/40 z-0" />

          <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-4 relative z-10">
            {steps.map((step, i) => <div key={step.id} data-index={i} className="relative flex md:flex-col items-start md:items-center gap-6 md:gap-6 w-full md:w-1/4 group">
                <Popover>
                  <PopoverTrigger asChild>
                    <button className="relative flex items-center justify-center w-16 h-16 md:w-24 md:h-24 rounded-full bg-card border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-lg shadow-primary/10 hover:shadow-primary/30 cursor-pointer shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background" aria-label={`Ver detalhes da etapa: ${step.title}`}>
                      <step.icon className="w-7 h-7 md:w-10 md:h-10 transition-transform duration-300 group-hover:scale-110" />
                      
                      {}
                      <span className="absolute -top-2 -right-2 md:-top-3 md:-right-3 w-7 h-7 md:w-9 md:h-9 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center text-xs md:text-sm font-bold border-4 border-background shadow-sm">
                        {step.id}
                      </span>
                    </button>
                  </PopoverTrigger>
                  <PopoverContent className="w-80 dark bg-popover border-border shadow-2xl p-6" sideOffset={16}>
                    <div className="flex items-center gap-3 mb-3">
                      <div className="p-2 rounded-md bg-primary/10 text-primary">
                        <step.icon className="w-5 h-5" />
                      </div>
                      <h4 className="font-serif font-bold text-lg text-foreground leading-tight">
                        {step.title}
                      </h4>
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.fullDesc}
                    </p>
                  </PopoverContent>
                </Popover>

                {}
                <div className="flex-1 md:text-center pt-1 md:pt-0">
                  <h3 className="text-xl font-semibold text-foreground mb-2 md:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm md:hidden">
                    {step.shortDesc}
                  </p>
                  
                  {}
                  <div className="hidden md:flex items-center justify-center gap-1.5 text-xs font-medium text-primary/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 mt-2">
                    <MousePointerClick className="w-3.5 h-3.5" />
                    <span>Clique para detalhes</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}